import { PickType } from '@nestjs/swagger';
import { DeviceCancellationInterface } from '../interfaces/device-cancellation.interface';
import { DeviceDto } from './device.dto';

export class DeviceCancellationDto
  extends PickType(DeviceDto, ['fcmToken'])
  implements DeviceCancellationInterface {}
